<div class="snapshot-section-box">
  <img src="/assets/logo/aha_heart.svg" alt="AHA Heart Logo">
  <div class="vl"></div>
  <div class="header-title">
    <h2> {{ section_title }} </h2>
  </div>
</div>